const it = {
    arrow_instruction: 'Scorri a destra e sinistra per vedere nuove opportunità',
    job_offer_instruction: 'Vedi i dettagli dell’offerta di lavoro',
    decline_offer_instruction: 'Scarta l’offerta di lavoro',
    share_offer_instruction: 'Condividi l’offerta con i tuoi contatti',
    apply_offer_instruction: 'Se vuoi candidarti clicca qui',
    save_offer_instruction: 'Salva l’offerta per candidarti in un secondo momento',
};
export default it;
